module.exports = __webpack_public_path__ + "static/img/mute_camera2.b9bb110.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/mute_camera2.png
// module id = hyBp
// module chunks = 24